module.exports = __webpack_public_path__ + "static/media/3ds.08776435.png";